import { vuexHandbook } from '@/store/composition/handbook'
import {
  ReclamationInnerReasonApi
} from '@/api/handbook/reclamation/ReclamationInnerReason/ReclamationInnerReasonApi'

const state = () => ({
  ...vuexHandbook.createState(),
  api: ReclamationInnerReasonApi
})

const getters = {
  ...vuexHandbook.createGetters()
}

const mutations = {
  ...vuexHandbook.createMutations()
}

const actions = {
  ...vuexHandbook.createActions()
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
